<Loader :loading="loading" />
 <div class="py-1">
 </div>            
      <div class="card border-0 w-100 bg-transparent">  
        <!-- Card Body: Filters -->
        <div class="card-body p-0">
          <div class="px-2">
            <div class="mb-0">
              <div class="d-flex flex-wrap align-items-center gap-2">
                <div
                  v-for="(filter, index) in appliedFilters"
                  :key="index"
                  class="badge bg-light text-dark border rounded-pill px-3 py-2 d-flex align-items-center"
                  @click="toggleSearchInput(filter)"
                >
                  <span class="me-2 d-flex align-items-center gap-1">
                    <span>{{ filter.label }}</span>
                    <span v-if="searchQuery[index]" class="d-flex align-items-center">
                      <span class="vr mx-3 ">|</span>
                      <span>{{ searchQuery[index] }}</span>
                    </span>
                  </span>
                  <i class="bx bx-x cursor-pointer" @click.stop="removeFilter(filter)"></i>
                </div>
        
                <!-- Add Filter Button -->
                  <a class="dropdown-toggle shadow btn btn-sm btn-primary rounded-3 text-decoration-none text-xxs" type="button" data-bs-toggle="dropdown">
                    <i class="bi bi-search fs-6"></i>
                  </a>

                  <div class="dropdown-menu p-3 shadow rounded-3" style="width: 260px;">
                     <p class="border-bottom text-xs">Search Filters</p>
                    <ul class="list-unstyled mb-0">

                      <li v-for="(filter, index) in filterOptions" class="mb-2 d-flex align-items-center filter-item text-xs" :key="index" v-if="!appliedFilters.includes(filter)">
                        <a
                          class="text-decoration-none text-dark"
                          href="#"
                          @click.prevent="selectFilter(filter)"
                        >
                          {{ filter.label }}
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                </div>
     
              <!-- Filter Search Inputs -->
              <div v-for="(filter, index) in appliedFilters" :key="index" class="mt-2">
                <div v-if="activeSearchFilter === filter.key" class="d-flex gap-2 mt-2 dropdown">
                  <input
                  v-model="searchQuery[filter.key]"
                    type="text"
                    class="form-control search-input text-xs w-25 rounded-pill p-1 shadow"
                    placeholder="Search..."
                  />
                  <button class="btn btn-sm btn-primary rounded-3 text-xxs" @click="applyFilter(filter)">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
      <div class="p-0">
        <div class="container py-3">
          <div class="row mt-3">
            <div
            v-for="member in filteredPortalUsers.filter(user => (stagging_domain || user.role?.role !== 'admin'))"
              :key="member.id"
              class="col-sm-4 col-md-4 col-lg-4 mb-4"
            >
              <div class="profile-card mb-2" @click="getProfileLink(member)">
                <div class="card-top bg-gray">
                  <div 
                  v-if="user_details.user_role === 'admin' || (portal_admin && user_details.user_id !== member.id)"
                  class="position-absolute top-0 end-0 mt-2 me-2 dropstart"
                  @click.stop
                >
                  <a 
                    href="#" 
                    class="text-dark" 
                    data-bs-toggle="dropdown" 
                    @click.stop="get_member_id(member.id)"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </a>
                  <ul class="dropdown-menu">
                    <li v-if="!adminUserIds.has(member.id)">
                      <a 
                        class="dropdown-item text-xs d-flex align-items-center gap-2" 
                        href="#" 
                        @click.stop="assign_portal_admin(member.id)"
                      >
                        <i class="bi bi-check"></i>
                        Assign Portal Admin
                      </a>
                    </li>
                    <li v-else>
                      <a 
                        class="dropdown-item text-xs d-flex align-items-center gap-2" 
                        href="#" 
                        @click.stop="unassign_portal_admin(member.id)"
                      >
                        <i class="bi bi-x-circle"></i>
                        Unassign Portal Admin
                      </a>
                    </li>
                  </ul>
                </div>
                </div>
                <img src="@/assets/images/user.png" class="avatar" alt="User">
                <div class="card-body">
                  <span v-if="adminUserIds.has(member.id)" class="custom-badge bg-info text-dark flex-shrink-0 position-absolute top-0 start-0 mt-2 ms-2">
                    Portal Admin
                  </span>
                  <h5 class="text-xs">{{ member.first_name }} {{ member.last_name }}</h5>
                  <p class="text-xs">{{ member.positions?.[0]?.position_name || member.role?.role || 'Member' }}</p>
                </div>
              </div>
            </div>
    
            <!-- Empty State -->
            <div v-if="!filteredPortalUsers.length" class="text-center text-muted py-5">
              <i class="bx bx-user-x fs-1"></i>
              <p class="mb-0 mt-2">No members available</p>
            </div>
          </div>
        </div>
      </div>

<teleport to="body">
<div class="view-portal modal fade " id="delete_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="portalMemberLabel">Delete Portal Members</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="deletePortalMembers">
        <div class="modal-body table-responsive">
          <div class="mb-3">
            <input
              type="text"
              v-model="searchQuery"
              class="form-control text-xs"
              placeholder="Search members by name..."
            />
          </div>
  
          <table class="table table-striped text-xs">
            <thead class="bg-dark text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Action<span class="ms-2"><input class="form-check-input" type="checkbox" id="select_all_checkbox":checked="SelectAllMembers" @change="toggleSelectAllMembers"/></span></th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in filteredPortalUsers" :key="user.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <div class="form-check">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      :id="'portal_member_check_' + user.id" 
                      :value="user.id" 
                      v-model="selectedUserIds"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Delete Members</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="view-portal modal fade " id="add_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="portalMemberLabel">Add Portal Members</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="addPortalMembers">
          <div class="modal-body table-responsive">
            <div class="mb-3">
              <input
                type="text"
                v-model="searchQuery"
                class="form-control text-xs"
                placeholder="Search members by name..."
              />
            </div>
    
            <table class="table table-striped text-xs">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Action <span class="ms-2"><input  class="form-check-input" type="checkbox" id="select_all_checkbox" :checked="areAllSelected" @change="toggleSelectAll"/></span></th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(user, index) in filteredUsers" :key="user.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ user.first_name }}</td>
                  <td>{{ user.last_name }}</td>
                  <td>{{ user.email }}</td>
                  <td>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'portal_member_check_' + user.id" 
                        :value="user.id" 
                        v-model="selectedUserIds"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-5">Add Members</button>
          </div>
        </form>
      </div>
    </div>
</div>
<div class="view-portal modal fade" id="assign_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="portalMemberLabel">Assigned Roles</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close" ></button>
      </div>
      <div class="modal-body table-responsive">
        <!-- Search Box -->
        <div class="mb-3">
          <input
            type="text"
            v-model="searchQuery"
            class="form-control text-xs"
            placeholder="Search members by name..."
          />
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-striped text-xs">
            <thead class="bg-dark text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Assigned Role</th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in portal_users" :key="user.user_id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>

                  <span
                  v-for="(position,posIndex) in user.positions"
                  :key="position.position_id"
                  class="btn-primary badge bg-primary text-white me-1"
                >
                  {{ position.position_name }}
                  <button
                    type="button"
                    class="btn-close text-white ms-1"
                    aria-label="Remove"
                    @click="remove_position(user.id,position.position_id, posIndex,portals_roles[0]?.id)"
                  ></button>

                </span>
                <div v-if="portals_roles.length">
                  <div v-for="portal in portals_roles" :key="portal.id" class="mb-4">
                    <select 
                      class="form-control text-xs mt-2"
                      @change="assign_position_to_portal_user($event, portal.id,user.id )"
                    >
                    <option value="">Select a position</option>
                    <option 
                      v-for="pos in available_positions(portal, user)"
                      :key="pos.id" 
                      :value="pos.id"
                    >
                      {{ pos.name }}
                    </option>
                    </select>
                  </div>
                </div>
                <p v-else>No portals or positions found.</p>

                  <div v-for="user in portal_positions" :key="user.user_id">
                    <h3>{{ user.first_name }} {{ user.last_name }}</h3>

                    <span v-if="user.positions.length === 0" class="text-muted">
                      No roles assigned
                    </span>
                  </div>
                  
                </td>
              </tr>
              <tr v-if="portal_users.length === 0">
                <td colspan="4" class="text-center text-muted">No users found.</td>
              </tr>
            </tbody>
          </table>
        </div> 
      </div>
    </div>
  </div>
</div>
</teleport>